import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Driver, OrganizationRiderDetail, OrganizationRiderService } from '@uzurv/clara';
import { isNullOrUndefined } from '@uzurv/core';
import { Driver as DOTSDriver, DriverService } from '@uzurv/dots';
import { AlertDialogComponent } from '../../dialogs/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-favorite-drivers-list-item',
  templateUrl: './favorite-drivers-list-item.component.html',
  styleUrls: ['./favorite-drivers-list-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FavoriteDriversListItemComponent implements OnInit, OnChanges {
  @Input()
  driver: Driver = new Driver();

  @Output()
  deleteDriver: EventEmitter<Driver> = new EventEmitter();

  dotsDriver: DOTSDriver;

  constructor(private driverService: DriverService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['driver']) {
      this.dotsDriver = isNullOrUndefined(this.driver) ? null : this.driverService.buildDotsDriverFromClaraDriver(this.driver);
    }
  }

  deleteFavoriteDriver(): void {
    this.deleteDriver.emit(this.driver);
  }
}
